var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutForm", [
    _c("div", { staticClass: "sector-edit" }, [
      _c("h1", [_vm._v("Edit Sector")]),
      _vm._v(" "),
      _c("div", { staticClass: "sector-edit__wrapper" }, [
        _c(
          "form",
          {
            staticClass: "form",
            attrs: { novalidate: "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("ValidationAlert", { attrs: { "error-list": _vm.errors } }),
            _vm._v(" "),
            _c("FormControlSector", {
              attrs: {
                name: "sectors",
                multiple: false,
                "include-ancestors": false,
              },
              model: {
                value: _vm.sector,
                callback: function ($$v) {
                  _vm.sector = $$v
                },
                expression: "sector",
              },
            }),
            _vm._v(" "),
            _vm.sector !== null
              ? _c("div", { staticClass: "sector-edit__new" }, [
                  _c("div", { staticClass: "form__group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.new_title,
                          expression: "formData.new_title",
                        },
                        { name: "validate", rawName: "v-validate" },
                      ],
                      staticClass: "form__control",
                      attrs: {
                        id: "name",
                        name: "name",
                        placeholder: "Enter a new name for this sector...",
                        required: "",
                      },
                      domProps: { value: _vm.formData.new_title },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.formData,
                              "new_title",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            return _vm.slugify_field(_vm.formData.new_title)
                          },
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "form__label", attrs: { for: "name" } },
                      [_vm._v("New Name")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form__validation" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.new_slug,
                          expression: "formData.new_slug",
                        },
                        { name: "validate", rawName: "v-validate" },
                      ],
                      staticClass: "form__control",
                      attrs: {
                        id: "slug",
                        name: "slug",
                        placeholder: "Enter a new slug for this sector...",
                        required: "",
                      },
                      domProps: { value: _vm.formData.new_slug },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.formData,
                            "new_slug",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "form__label", attrs: { for: "slug" } },
                      [_vm._v("New Slug")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form__validation" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form__group form__group--submit" },
                    [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: "submit",
                              expression: '"submit"',
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--primary",
                        },
                        [_vm._v("Save & Continue")]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }